import React from "react";
import {
  SlackContainer,
  SlackDescription,
  SlackHeader,
  SlackImage,
  SlackImageLinkWrapper,
} from "./styles";

import slackLogo from "../../../assets/images/Slack.png";

export default function Slack() {
  return (
    <SlackContainer>
      <SlackHeader>Gup&apos;s Corner Warrior Room Slack Chat</SlackHeader>
      <SlackDescription>
        Thanks for joining Gup&apos;s Corner and becoming a member of our
        community. One of the biggest perks of being a part of the community is
        access to our 24/7 premium Slack channel. Get instant alerts to Gup’s
        plays, hang out in the always active #golf channel, or find one of many
        topics that may interest you, all within the Gup’s Corner community. All
        we ask is that you remain respectful of one another and remember… what
        happens in Slack, STAYS in Slack.
        <br />
        <br />
        Click the image below to get started!
      </SlackDescription>
      <SlackImageLinkWrapper href="https://join.slack.com/t/gupscornerpremiumchat/shared_invite/zt-m20iuj3n-q4Qgc0VWo9SQXf1trDBg0A">
        <SlackImage src={slackLogo} />
      </SlackImageLinkWrapper>
      <SlackDescription>
        <i>
          <strong>PLEASE NOTE!</strong> If your membership has previously
          expired and you’ve recently rejoined us, we’ll need to manually
          reactivate you in Slack. Slack is an external program so it doesn’t
          integrate with our membership software. Just shoot a note to
          support@gupscorner.com and we’ll get you reactivated as soon as we
          can. Thanks for your understanding and welcome back!
        </i>
      </SlackDescription>
    </SlackContainer>
  );
}
